// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

// Object identity establishes local provenance; no serialized field or Error
// name can grant trust to a remote payload. Keep the original copy separately
// so reading it never invokes getters or forwards a later message mutation.
const localMessages = new WeakMap<object, string>();

/** Only for app-authored copy, never a message received from a transport. */
export function createLocalError(
  message: string,
  options?: ErrorOptions
): Error {
  const error = new Error(message, options);
  localMessages.set(error, message);
  return error;
}

export function localErrorMessage(value: unknown): string | undefined {
  return value !== null && typeof value === 'object'
    ? localMessages.get(value)
    : undefined;
}
